import { ServiceBase } from '../../../../core/services/ServiceBase'
import Proxy from './proxy'

class Service extends ServiceBase {
  getTotalSeperateCompanies(params) {
    return this.getData(() => Proxy.getTotalSeperateCompanies(params))
  }

  getPortfolioOverview(params) {
    return this.getData(() => Proxy.getPortfolioOverview(params))
  }
  exportPortfolioOverview(params) {
    return this.getFileDownload(() => Proxy.exportPortfolioOverview(params))
  }

  getScoreDistribution(params) {
    return this.getData(() => Proxy.getScoreDistribution(params))
  }
  exportScoreDistribution(params) {
    return this.getFileDownload(() => Proxy.exportScoreDistribution(params))
  }

  getTopByIndustry(params) {
    return this.getData(() => Proxy.getTopByIndustry(params))
  }
  getTopByProvince(params) {
    return this.getData(() => Proxy.getTopByProvince(params))
  }
  getBussinessSize(params) {
    return this.getData(() => Proxy.getBussinessSize(params))
  }
  getYearOfOperation(params) {
    return this.getData(() => Proxy.getYearOfOperation(params))
  }
  exportPortfolioSegment(params) {
    return this.getFileDownload(() => Proxy.exportPortfolioSegment(params))
  }

  getTopHighestPortfolio(params) {
    return this.getData(() => Proxy.getTopHighestPortfolio(params))
  }
  getTopHighestIndustry(params) {
    return this.getData(() => Proxy.getTopHighestIndustry(params))
  }
  exportTopHighestScore(params) {
    return this.getFileDownload(() => Proxy.exportTopHighestScore(params))
  }

  getAlertHighlight(params) {
    return this.getData(() => Proxy.getAlertHighlight(params))
  }
  getCompanyAlerts(params) {
    return this.getData(() => Proxy.getCompanyAlerts(params))
  }
}

export default new Service()
